module.exports = __webpack_public_path__ + "assets/img/8b0dc494a1a7c9309660839a22eac633.png";